import { Component, OnInit } from '@angular/core';
import { PaymentStateEnum } from '../../models/payment-state.enum';
import { PaymentService } from '../../services/payment.service';
import { PblLiabilityPaymentStatusEnum } from '../../models/pbl-payment-status.enum';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss']
})
export class ResultComponent implements OnInit {
  PaymentStateEnum = PaymentStateEnum;
  PblLiabilityPaymentStatusEnum = PblLiabilityPaymentStatusEnum;
  paymentState: PaymentStateEnum;
  liabilityPaymentStatus: PblLiabilityPaymentStatusEnum;

  constructor(private paymentService: PaymentService) {}

  ngOnInit(): void {
    this.liabilityPaymentStatus = this.paymentService.payment.paymentStatus;
    this.paymentState = this.paymentService.payment.paymentState;
  }
}
